import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";

export class LonerPinTheWinIntroPresentation implements SimplePresentation {
    private _mainTL: gsap.core.Timeline;
    private _controller: SimplePresentationRunnerController;

    shouldRun(): boolean {
        if (Loner.model.isRestore && (Loner.model.data.nextMode === LonerGameMode.FEATURE_PIN_THE_WIN || Loner.model.data.mode === LonerGameMode.FEATURE_PIN_THE_WIN)) {
            Loner.pinTheWinIntroView.handleRestore();
        }
        return Loner.model.data.mode === LonerGameMode.NORMAL && Loner.model.data.nextMode === LonerGameMode.FEATURE_PIN_THE_WIN;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._mainTL = gsap.timeline();
        this._mainTL.add(Loner.pinTheWinIntroView.showIntro(() => {
            this.complete()
        }));
    }

    private complete(): void {
        this._controller.finish();
    }

}